module.exports = __webpack_public_path__ + "static/img/14002005.f86d7d58.png";